import { render, staticRenderFns } from "./TemplateQuery.vue?vue&type=template&id=bae7a056&"
import script from "./TemplateQuery.vue?vue&type=script&lang=js&"
export * from "./TemplateQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports